module.exports = {"410302001":"西关街道","410302002":"西南隅街道","410302003":"西北隅街道","410302004":"东南隅街道","410302005":"东北隅街道","410302006":"南关街道","410302007":"洛浦街道","410302008":"邙山街道","410302009":"道北路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410302.json
// module id = 1538
// module chunks = 0